export type Plain = 'boolean'

export interface Config {
  type: 'boolean'
  defaultValue?: boolean
}

export type PlainResult = boolean
export type Result = boolean

const transformValue = (value: any, config?: Config): boolean => {
  const defaultValue = config?.defaultValue ?? false

  if (typeof value !== 'boolean') {
    return defaultValue
  }

  return value
}

export const transform = (value: any, config?: Config | Plain): boolean => {
  if (config === 'boolean') {
    return transformValue(value)
  }

  return transformValue(value, config)
}
